export const PROVIDERS = ['anthropic', 'openai', 'gemini', 'openrouter', 'mock'];
/** Mention handle → provider. Only these explicit handles invoke AI (CR-T39, ADR-003). */
export const MENTION_HANDLES = {
    claude: 'anthropic',
    codex: 'openai',
    gemini: 'gemini',
    /** Free models only, via the user's own OpenRouter connection (OpenRouter's free router by default). */
    ai: 'openrouter',
    mock: 'mock',
};
export const PROVIDER_LABEL = {
    anthropic: 'Claude (Anthropic)',
    openai: 'Codex / OpenAI',
    gemini: 'Gemini (Google)',
    openrouter: 'Ücretsiz AI (OpenRouter ücretsiz modelleri)',
    mock: 'MOCK — test sağlayıcısı (gerçek AI değil)',
};
/**
 * Deterministic mention parser for persistent room messages.
 * - Only `@handle` tokens at a word boundary are recognised (not e-mail addresses).
 * - Each provider is invoked at most once per message, in order of first appearance.
 * - Text inside inline code or fenced code blocks is ignored.
 * This parser is NEVER applied to Team Chat (ADR-004) or to AI output (loop prevention).
 */
export function parseMentions(text) {
    const withoutCode = text.replace(/```[\s\S]*?```/g, ' ').replace(/`[^`\n]*`/g, ' ');
    const re = /(^|[\s([{,;:!?"'])@([a-z][a-z0-9_-]{1,31})\b/gi;
    const seen = new Set();
    const out = [];
    for (const m of withoutCode.matchAll(re)) {
        const handle = (m[2] ?? '').toLowerCase();
        const provider = MENTION_HANDLES[handle];
        if (provider && !seen.has(provider)) {
            seen.add(provider);
            out.push({ handle, provider });
        }
    }
    return out;
}
//# sourceMappingURL=providers.js.map